module.exports = __webpack_public_path__ + "static/11.3_ancient_greece-8a94e75ee0dbd9ee56222cb0008fc04b.pdf";